import * as React from 'react';
import {
  PersonTextContainer,
  PersonNameText,
  PersonApartmentInfoContainer,
  PersonApartmentInfoText,
} from 'src/components/MatchComponents/PersonDetails';
import DateDropoffPickup from 'src/components/MatchComponents/DateDropoffPickup';
import * as moment from 'moment';
import { findMatch } from 'src/schema';
import { ProfilePicture } from 'src/pages/PostCheckout/PostCheckoutPage';
import styled from 'styled-components';
import RectangleButton from 'src/components/Buttons/RectangleButton';
import { Link } from 'react-router-dom';

interface props {
  onConfirm?: () => void;
  match: findMatch;
  startDate: moment.Moment;
  endDate: moment.Moment;
}

const DetailText = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;

  color: #333333;
  margin-top: 24px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 14px;
  justify-content: center;
  align-items: center;
`;

const AgreeText = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 20px;

  color: #333333;
  margin-top: 14px;
`;

const StyledLink = styled(Link)`
  font-weight: 500;
  font-size: 11px;
  line-height: normal;
  text-decoration: underline !important;

  color: #00144d;
  :hover {
    cursor: pointer;
  }
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 34px;
`;

const ModalHeaderText = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: normal;
  text-align: center;

  color: #333333;
`;

const ConfirmModal = ({ onConfirm, match, startDate, endDate }: props) => {
  return (
    <div style={{ padding: '0px 24px 0px 24px' }}>
      <ModalHeaderContainer>
        <ModalHeaderText>Confirm Storage Booking</ModalHeaderText>
      </ModalHeaderContainer>
      <div>
        <PersonTextContainer>
          <ProfilePicture src={match.findMatch!.owner.profilePicture!} alt="oops" />
          <PersonNameText>
            {match.findMatch!.owner.firstName} {match.findMatch!.owner.lastName}
          </PersonNameText>
          <PersonApartmentInfoContainer style={{ marginTop: 4 }}>
            <PersonApartmentInfoText>{match.findMatch!.address}</PersonApartmentInfoText>
          </PersonApartmentInfoContainer>
        </PersonTextContainer>
        <hr />
        <DateDropoffPickup startDate={startDate} endDate={endDate} />
        <hr />
        <DetailText>
          You’ll only pay after dropping off your items. Thanks for storing with us!
        </DetailText>
        <ButtonContainer>
          <RectangleButton onClick={onConfirm}>Confirm</RectangleButton>
          <AgreeText>
            * By hitting confirm, you agree to the{' '}
            <StyledLink to="/terms-of-service" target="_blank">
              Terms of Service
            </StyledLink>
            .
          </AgreeText>
        </ButtonContainer>
      </div>
    </div>
  );
};

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/pages/MatchPage/components/ConfirmModal.tsx